declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GA_ID = process.env.REACT_APP_GA_ID;

export const initAnalytics = () => {
  if (!GA_ID || document.getElementById("ga4")) return;

  const script = document.createElement("script");
  script.id = "ga4";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // o page_view inicial sai junto com o da rota, logo abaixo
  window.gtag("config", GA_ID, { send_page_view: false });
};

/** Troca ULID/número por :id — senão cada banner vira uma URL diferente no relatório. */
const normalizar = (path: string) =>
  path
    .replace(/\/[0-9A-HJKMNP-TV-Z]{26}(?=\/|$)/gi, "/:id")
    .replace(/\/\d+(?=\/|$)/g, "/:id");

export const trackPageView = (path: string) => {
  if (!GA_ID || !window.gtag) return;

  window.gtag("event", "page_view", {
    page_path: normalizar(path),
    page_location: window.location.origin + normalizar(path),
    page_title: document.title,
  });
};